module.exports = __webpack_public_path__ + "static/imageLibreta-42af90ad6241d7c12ed2b7b38160e6be.png";